/**
 * Accessible touch targets for Pressable/TouchableOpacity.
 * WCAG 2.2 SC 2.5.8: https://www.w3.org/WAI/WCAG22/Understanding/target-size-minimum
 */

export const MINIMUM_TARGET_SIZE = 48;
export const MINIMUM_SPACING_BETWEEN_TARGETS = 12;

export type HitSlop = { top: number; right: number; bottom: number; left: number };

/** Extends visual element to 48px touch target. Use when visible size is smaller. */
export function getAccessibleHitSlop(visualSize: number): HitSlop {
  const needed = Math.max(0, Math.ceil((MINIMUM_TARGET_SIZE - visualSize) / 2));

  return { top: needed, right: needed, bottom: needed, left: needed };
}

/** HitSlop for 40×40px icon buttons. */
export const ICON_BUTTON_HIT_SLOP = getAccessibleHitSlop(40);

/** HitSlop for ~16×16px icon buttons (Gluestack `size="sm"` icons). The 40px
 * slop is insufficient for these smaller visuals; 16px needs ~16px of slop
 * per side to reach a 48px target. */
export const SMALL_ICON_BUTTON_HIT_SLOP = getAccessibleHitSlop(16);

/**
 * Minimum-height class that grows the interactive box to a 48px touch target.
 * Use instead of (or in addition to) `hitSlop` when the button must be full-size
 * on web: react-native-web's Pressable silently ignores `hitSlop`, so only
 * growing the box itself is reliable across both platforms.
 */
export const TOUCH_TARGET_MIN_H = 'min-h-[48px]';
